import { ViewController } from "@gaming/srvg-classes-core";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { MatchdayPickerLeagueView } from "../../View/MatchdayPickerLeagueView";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class MatchdayPickerLeagueViewController extends ViewController {
    matchdaypickerLeagueView:MatchdayPickerLeagueView;

    // signals program start
    startup:boolean;

    constructor(options) {
        options = options || {};
        options.name = options.name || 'matchdaypickerLeagueViewController';
        options.view = options.matchdayPickerLeagueView || null;
        super(options);

        this.startup = false;

        this.matchdaypickerLeagueView = options.matchdayPickerLeagueView || null;

        // register for ChunkChangeEvents
        app.timelineController.addSubscriberForEvent(this, ChunkChangeEvent);
    }

    highlightCurrentMatchday(matchday) {
        var selector = '#matchdayPickerLeagueView #md' + matchday;
        $(".currentMatchday").removeClass('currentMatchday');
        $(".currentMatchday").removeClass('pastOrUpcomingMatchday');
        $(selector).addClass('currentMatchday');
    }

    // called from customerIntegrationController
    highlightSelectedMatchday(matchday) {
        var selector = '#matchdayPickerLeagueView #md' + matchday;
        $(".selectedMatchday").removeClass('selectedMatchday');
        $(".selectedMatchday").removeClass('pastOrUpcomingMatchday');
        $(selector).addClass('selectedMatchday');
    }

    // ************************** Event handlers **************************

    handlePhaseChangeEvent(event:PhaseChangeEvent, provider) {
        var currentMatchday;
        // fetch current matchday and season number
        // TODO: replace magic number, maybe we'll have more than 30 matchdays in a future version
        var totalMatchdays = 30;
        var seasonString = null;
        // event.chunk.prev == null onlyy for initial loading
        // pre_match phase and initial
        if (event.chunk.prev==null && event.phase.name=="pre_match"){
            currentMatchday = app.timeline.currentChunkModel.chunk.nr - 1;
        }
        else {
            currentMatchday = app.timeline.currentChunkModel.chunk.matches[0].matchset.nr;
        }
        // there are 30 chunks in a (normal) season so the last one would be the 29th of the array
        // we need to check for the first one of the following season which matches
        // the total amount of chunks (usually 30)
        if(app.timeline.chunkRangeModel.chunks[totalMatchdays]) {
            seasonString = __("Season") + " " + (app.timeline.chunkRangeModel.chunks[totalMatchdays].competition.nr);
        }

        // mark the current matchday in the matchday picker
        this.highlightCurrentMatchday(currentMatchday);

        // set classes for all matchdays (current season +2 of the upcoming one)
        for(var i = 1; i<totalMatchdays+3; i++) {

            var previouslySelectedMatchday = $('.selectedMatchday');

            // put grey color to div if it isn't the current matchday AND
            // if it isn't the currently selected matchday
            if(currentMatchday != i && ! $('#matchdayPickerLeagueView #md' + i).hasClass('selectedMatchday')) {
                $('#matchdayPickerLeagueView #md' + i + '').addClass('normalMatchday');
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('currentMatchday');
                // remove style from case getDisablePastMatchdays
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('inactiveMatchday');
            }

            // set classes for current matchday
            if (currentMatchday == i) {
                $('#matchdayPickerLeagueView #md' + i + '').addClass('currentMatchday');
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('normalMatchday');
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('nextMatchday');
                // remove style from case getDisablePastMatchdays
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('inactiveMatchday');
                $('#matchdayPickerLeagueView #md' + i + '').css('border-color', '#fff');
            }

            // set classes for 1st matchday(after current matchday)
            if (currentMatchday == i-1 ) {
                // on startup we set current matchday + 1 as selected
                if(this.startup == false) {
                    $('#matchdayPickerLeagueView #md' + i + '').addClass('selectedMatchday');
                    $('#matchdayPickerLeagueView #md' + i + '').removeClass('nextMatchday');
                    $('#matchdayPickerLeagueView #md' + i + '').removeClass('normalMatchday');
                }
                // after startup has simply a white font
                else {
                    $('#matchdayPickerLeagueView #md' + i + '').addClass('nextMatchday');
                    $('#matchdayPickerLeagueView #md' + i + '').removeClass('normalMatchday');
                }
            }

            // set classes for 2nd matchday(after current matchday)
            if ( currentMatchday == i-2) {
                $('#matchdayPickerLeagueView #md' + i + '').addClass('nextMatchday');
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('normalMatchday');
            }

            if($('#matchdayPickerLeagueView #md' + i).hasClass('selectedMatchday')) {
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('normalMatchday');
                $('#matchdayPickerLeagueView #md' + i + '').removeClass('nextMatchday');
            }

        }

        // set matchday visibility
        // from matchday 29 on the next season chunks are available, therefore we hide the
        // first six matchdays in the matchday picker and make the first two matchdays of the
        // upcoming season visible
        if (currentMatchday > 28) {
            // hide first six matchdays
            $('#matchdayPickerLeagueView #md1').hide();
            $('#matchdayPickerLeagueView #md2').hide();

            // show season string and first two matchdays of the following season
            $('#matchdayPickerLeagueView #md31').css('display', 'inline-block');
        }
        else {
            // show first two matchdays
            $('#matchdayPickerLeagueView #md1').show();
            $('#matchdayPickerLeagueView #md2').show();

            // hide first matchday of the following season
            $('#matchdayPickerLeagueView #md31').hide();
        }

        // style for the past matchdays and current matchday with betstop in case of getDisablePastMatchdays
        if (srvg.featuresInstances.getDisablePastMatchdays()) {
            for(var i = 1; i<=currentMatchday; i++) {
                if ((currentMatchday == i) && (app.timeline.currentChunkModel.chunk.betstop <= app.server.getTime())) {
                    $('.currentMatchday' + '').css('border-color', 'transparent');
                    $('.currentMatchday' + '').addClass('inactiveMatchday');

                } else if (currentMatchday != i) {
                    $('#matchdayPickerLeagueView #md' + i + '').addClass('inactiveMatchday');
                }
            }
        }

        // special case: when the season changes the first phase will be the pre_season phase.
        // in this case we need to move the selected matchday indicator by hand to the first matchday
        // otherwise it would stay at the previously selected matchday of the last season
        // all other matchdays (2-31) are set back to standard look
        if(event.phase.name == "pre_league"){
            // matchday 4-31 was selected, remove selected indicator, add standard class
            if($(previouslySelectedMatchday).data('matchday')>3){
                $(previouslySelectedMatchday).removeClass('selectedMatchday');
                $(previouslySelectedMatchday).addClass('normalMatchday');
            }
            // matchday 2 or 3 was selected, remove selected indicator, add standard class
            else if($(previouslySelectedMatchday).data('matchday')>1 &&
                $(previouslySelectedMatchday).data('matchday')<4){
                $(previouslySelectedMatchday).removeClass('selectedMatchday');
                $(previouslySelectedMatchday).addClass('nextMatchday');
            }

            // remove standard class and add selected class to matchday 1
            $('#matchdayPickerLeagueView #md1').removeClass('normalMatchday');
            $('#matchdayPickerLeagueView #md1').addClass('selectedMatchday');
        }
        // another special case...
        // when the betstop phase is reached we need to set the selected matchday to current matchday +1 if
        // the previously selected matchday is in the past or new current matchday
        else if(event.phase.name == "betstop" ) {
            if($(previouslySelectedMatchday).data('matchday')<currentMatchday ||
                $(previouslySelectedMatchday).data('matchday')==currentMatchday){
                $(previouslySelectedMatchday).removeClass('selectedMatchday');

                // as previously selected matchday is in the past we can be sure that it is a normal matchday
                // until it was the new current matchday
                if($(previouslySelectedMatchday).data('matchday')!=currentMatchday) {
                    $(previouslySelectedMatchday).addClass('normalMatchday');
                }

                $('#matchdayPickerLeagueView #md' + (currentMatchday+1)).addClass('selectedMatchday');
            }
        }
        // in all other phases readd the selected matchday indicator
        else {
            $(previouslySelectedMatchday).addClass('selectedMatchday');
        }

        if(this.startup == false){
            this.startup = true;
        }
    }


    // hide all matchdays and cursor of the matchdaypicker
    handleTimeoutEvent( event, provider ) {
        var totalMatchdays = 30;
        for(var i = 1; i<totalMatchdays+3; i++) {
            $('#matchdayPickerLeagueView #md' + i).css('display','none');
        }
        $('#matchdayPickerLeagueView').css('cursor', 'default');
    }
}